var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmailNew = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7845 16.128C8.0605 16.128 6.0325 14.292 6.0325 11.388C6.0325 8.136 8.2885 6.384 10.8565 6.384C13.5445 6.384 15.2845 7.992 15.2845 10.776C15.2845 12.744 14.3365 13.704 13.1605 13.704C12.4645 13.704 12.0085 13.26 11.8645 12.804C11.4925 13.32 10.9765 13.704 10.2445 13.704C8.9125 13.704 8.1805 12.768 8.1805 11.46C8.1805 9.996 9.1885 8.808 10.7005 8.808C11.2765 8.808 11.7445 9.048 12.0085 9.468L12.1645 8.892H12.9325L12.6565 11.892C12.6445 12.036 12.6325 12.132 12.6325 12.192C12.6325 12.672 12.8605 12.852 13.2325 12.852C13.9645 12.852 14.2885 11.976 14.2885 10.752C14.2885 8.484 12.9685 7.236 10.7965 7.236C8.9125 7.236 7.0285 8.688 7.0285 11.388C7.0285 13.92 8.7925 15.276 10.7845 15.276C11.8525 15.276 12.6685 15.108 13.7845 14.556V15.492C12.6925 15.948 11.9365 16.128 10.7845 16.128ZM10.3285 12.852C11.2525 12.852 11.8045 11.988 11.8045 11.028C11.8045 10.188 11.3965 9.66 10.6165 9.66C9.7525 9.66 9.1645 10.44 9.1645 11.496C9.1645 12.396 9.6085 12.852 10.3285 12.852Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 11C19 15.418 15.418 19 11 19C6.582 19 3 15.418 3 11C3 6.582 6.582 3 11 3C15.418 3 19 6.582 19 11Z",
    stroke: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmailNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EmailNew.1c089c25.svg";
export { ForwardRef as ReactComponent };